<template>

    <div class="font-ed">
        <!-- <router-link to="/" class="list-group-item list-group-item-action bg-dark" >Home</router-link>
        <router-link to="/about" class="list-group-item list-group-item-action bg-dark">About</router-link>  -->

        <router-link to="/amortizations" class="list-group-item list-group-item-action bg-dark-ed">Pratiche Cambiali</router-link>
        <router-link to="/search-promissory-notes" class="list-group-item list-group-item-action bg-dark-ed">Gestione Cambiali</router-link>
      <!-- <router-link to="/editor" class="list-group-item list-group-item-action bg-dark-ed">Editor</router-link>
        <router-link to="/editor-fabric" class="list-group-item list-group-item-action bg-dark-ed">Editor Fabric</router-link>
-->
        <router-link to="/profile/settings" class="list-group-item list-group-item-action bg-dark-ed">Profilo
        </router-link>

        <router-link to="/profile/margin-settings" class="list-group-item list-group-item-action bg-dark-ed">Impostazioni Stampa
        </router-link>
        <router-link to="/profile/notifications" class="list-group-item list-group-item-action bg-dark-ed">Notifiche
        </router-link>
        <router-link to="/profile/plan" class="list-group-item list-group-item-action bg-dark-ed">Abbonamento</router-link>
        <a @click="logout()" class="list-group-item list-group-item-action bg-dark-ed">Esci</a>

    </div>

</template>

<script>
  export default {
    name: 'NavMain',
    methods: {
      logout: function () {
        this.$cookies.remove('user')
        this.$cookies.remove('token')
        this.$router.push({name: 'login'})
      }
    }
  }
</script>

<style scoped>
    /* .bg-dark-ed {
        background-color: #222939 !important;
    } */

    .font-ed {
        font-size: 14px;
        font-weight: 300;
    }

</style>
